import { render } from "./iosLiseOld.vue?vue&type=template&id=325222ad&scoped=true"
import script from "./iosLiseOld.vue?vue&type=script&lang=js"
export * from "./iosLiseOld.vue?vue&type=script&lang=js"

import "./iosLiseOld.vue?vue&type=style&index=0&id=325222ad&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325222ad"]])

export default __exports__